export default {
      id: "phone-usage",
      viewBox: "0 0 10.5 10.5",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#phone",
      toString: function () {
        return this.url;
      }
    }